import L from 'leaflet';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow
});

export function leaflet() {

    window.initLeafletMap = function (mapId, markerData) {

        const mapcontainer = document.getElementById(mapId);
        if (!mapcontainer) return;

        const map = L.map(mapcontainer).setView([51.9302218, 4.32], 14.2);

        let bounds = [];
        window.leafletMarkers = []; // 👈 store markers globally

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: '&copy; OpenStreetMap contributors',
        }).addTo(map);

        markerData.forEach(marker => {
            const m = L.marker([marker.lat, marker.lng])
                .addTo(map)
                .bindPopup(marker.popup);

            window.leafletMarkers.push(m); // 👈 save reference
            bounds.push([parseFloat(marker.lat), parseFloat(marker.lng)]);
        });

        if (bounds.length > 0) {
            map.fitBounds(bounds, {
                padding: [10, 10]
            });
        }

        window.leafletMap = map;
    }

    window.openPopup = function(index) {
        const marker = window.leafletMarkers[index];

        if (!marker) return;

        marker.openPopup();

        // Optional: center map on marker
        window.leafletMap.setView(marker.getLatLng(), 16);
    }

    return 'leaflet';

}
